import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';
import { Button, List, Tag, Switch, Picker, DatePicker, SwipeAction, PageIndicator, Popup } from 'antd-mobile';
import ReactToPrint from 'react-to-print';
import {
    FilterOutlined,
    SortAscendingOutlined,
    SortDescendingOutlined
} from '@ant-design/icons';
import Icofont from 'react-icofont';
import { createUseStyles } from 'react-jss'

import moment from 'moment-timezone';
import 'moment/locale/ru';
import SortedSet from 'collections/sorted-set'

import Print from '../Print'
import './index.css'
import { CalendarItem } from 'fennec-ui';

const useStyles = createUseStyles({
    button: {
        marginLeft: "10px"
    },
    printLink: {
        '&:hover': {
            color: "#40a9ff !important"
        }
    },
    pickerItem: {
        '& .am-list-line .am-list-extra': {
            display: "none"
        },
    },
    Act: {
        '&.am-list-item .am-list-line .am-list-brief': {
            textAlign: "left",
            paddingTop: "0px",
            paddingBottom: "14px",
            fontWeight: "300",
            fontSize: "16px",
            marginTop: "0px"
        },
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingBottom: "0px",
            fontWeight: "300",
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            // display: "none"
            position: "absolute",
            right: "0",
            top: "3px",
        },
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-list-line': {
            // paddingRight: "0px",
            padding: "0px",
            display: "block",
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        }
    },
    Obj: {
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingTop: "0px",
            paddingBottom: "0px",
            fontWeight: "300",
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            position: "absolute",
            right: "0",
            top: "3px",
        },
        '&.am-list-item .am-list-line .am-list-extra': {
            textAlign: "left",
            paddingTop: "0px",
            paddingBottom: "14px",
            fontWeight: "300"
        },
        '&.am-list-item': {
            paddingLeft: "0px",
        },
        '&.am-list-item .am-list-line': {
            display: "block",
            paddingRight: "0px"
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        }
    },
    Time: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '& .am-list-line': {
            display: "block",
        },
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingBottom: "0px",
            paddingTop: "0px",
            fontWeight: "300"
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            position: "absolute",
            right: "0",
            top: "3px",
        },
        '&.am-list-item .am-list-line .am-list-brief': {
            textAlign: "left",
            paddingTop: "0px",
            fontSize: "16px",
            paddingBottom: "14px",
            fontWeight: "300",
            marginTop: "0px"
        },
        '&.am-list-item .am-list-line .am-list-extra': {
            textAlign: "left",
            paddingTop: "0px",
            fontSize: "16px",
            paddingBottom: "14px",
            fontWeight: "300"
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        },
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        },
    },
    Boolean: {
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingTop: "0px",
            paddingBottom: "0px",
            fontWeight: "300",
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            position: "absolute",
            right: "0",
            top: "3px",
        },
        '&.am-list-item .am-list-line .am-list-extra': {
            textAlign: "left",
            paddingTop: "0px",
            paddingBottom: "14px",
            fontWeight: "300"
        },
        '&.am-list-item': {
            paddingLeft: "0px",
        },
        '&.am-list-item .am-list-line': {
            display: "block",
            paddingRight: "0px"
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        }
    },
    Float: {
        '&.am-list-item': {
            paddingLeft: "0px"
        },
    },
    Integer: {
        '&.am-list-item': {
            display: "initial",
        },
        '&.am-list-item .am-list-line': {
            paddingLeft: "0px",
            display: "block",
        },
        '&.am-list-item.am-input-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-input-clear': {
            position: "absolute",
            right: "0",
            top: "0",
            backgroundSize: "17px auto",
            width: "17px",
            height: "17px",
            marginTop: "0px"
        },
        '&.am-list-item .am-input-label': {
            width: "100%",
            fontSize: "14px",
            minHeight: "20px",
            lineHeight: "20px",
            fontWeight: "300",
        },
        '&.am-list-item .am-input-control': {
            paddingTop: "0px",
            paddingBottom: "14px",
            fontSize: "14px"
        },
        '&.am-list-item .am-input-control input': {
            fontSize: "16px",
            color: "#888"
        },
        '& .am-input-control input': {
            textAlign: "start",
        },
    },
    String: {
        '&.am-list-item': {
            paddingLeft: "0px",
            display: "block",
        },
        '&.am-list-item .am-textarea-clear': {
            position: "absolute",
            right: "0",
            top: "0",
            backgroundSize: "17px auto",
            width: "17px",
            height: "17px",
            marginTop: "0px"
        },
        '&.am-list-item .am-textarea-label': {
            width: "100%",
            fontSize: "14px",
            minHeight: "20px",
            lineHeight: "20px"
        },
        '&.am-list-item .am-textarea-control': {
            paddingTop: "0px",
            paddingBottom: "14px"
        },
        '&.am-list-item .am-textarea-control textarea': {
            fontSize: "16px",
            color: "#888"
        },
        '& .am-textarea-control textarea': {
            textAlign: "start",
        },
    },
    Frm: {

    },
    Search: {
        '& .am-search': {
            height: "32px",
            padding: "0 2px",
            backgroundColor: "#efeff4",
        },
        '& .am-search-cancel.am-search-cancel-show.am-search-cancel-anim': {
            marginRight: "6px!important",
        }
    }
})

const locale = {
    prevText: 'Назад',
    nextText: 'Далее',
};

const chunk = (myArray, chunk_size) => {
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];
    for (index = 0; index < arrayLength; index += chunk_size) {
        var myChunk = myArray.slice(index, index + chunk_size);
        tempArray.push(myChunk);
    }
    return tempArray;
}

export default function Filtered(props) {
    const classes = useStyles()
    const [current, setCurrent] = useState(1);
    const [count] = useState(15);
    const [sorting, setSorting] = useState({ field: "", order: "ASC", f: () => { return "" } });
    const [filter, setFilter] = useState({});
    const [filtered, setFiltered] = useState(false);
    const [opened, setOpened] = useState(false);
    const [quickFilterValue, setQuickFilterValue] = useState("");
    const { data, filters, content, item, addition, noPagination, noPrint, onPrint, printHref, title, quickFilter } = props;
    var collection = {};
    const setCollection = (obj) => { collection = obj };
    useEffect(() => {
        var fld = filters.find(item => !!item.sorted);
        if (fld && !sorting.field) {
            setSorting({ field: fld.field, order: fld.sorted, f: (fld.value) ? fld.value : () => "" })
        }
    }, [filters]);

    const sortData = (sorting, data) => {
        if (sorting.field) {
            data.sort(function (a, b) {
                if (sorting.order === "ASC" && sorting.f(a) > sorting.f(b)) {
                    return 1;
                }
                if (sorting.order === "ASC" && sorting.f(a) < sorting.f(b)) {
                    return -1;
                }
                if (sorting.order === "DESC" && sorting.f(a) < sorting.f(b)) {
                    return 1;
                }
                if (sorting.order === "DESC" && sorting.f(a) > sorting.f(b)) {
                    return -1;
                }
                // a должно быть равным b
                return 0;
            });
        }
        return data;
    };
    const sortByFilters = (filters, data) => {
        var fld = filters.find(item => !!item.sorted);
        if (fld) {
            if (!sorting.field) {
                //setSorting({ field: fld.field, order: fld.sorted, f: (fld.value) ? fld.value : (fld) => "" });
                return sortData({ field: fld.field, order: fld.sorted, f: (fld.value) ? fld.value : () => "" }, data);
            } else {
                return sortData(sorting, data);
            }
        }
        return data;
    };
    const quickFilterValueChange = (e) => {
        setQuickFilterValue(e);
    };
    const filterByQuickFilter = (value, filters, data) => {
        if (quickFilter === false) return data;
        return data.filter(item => {
            for (let i = 0; i < filters.length; i++) {
                const filter = filters[i];
                // if(filter.type === "string"){
                var v = filter.value(item) + "";
                if (v.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                    return true;
                }
                // }
            }
            return false;
        });
    };
    const filterByFilters = (filters, data) => {
        return filterByQuickFilter(quickFilterValue, filters, data).filter(item => {
            for (let i = 0; i < filters.length; i++) {
                const f = filters[i];
                var v = f.value(item);

                if (f.filter && f.type === "string") {
                    var set = collection[f.field];
                    if (!set) {
                        set = new SortedSet();
                    }
                    if (v !== null) {
                        set.push(v);
                    }
                    // else {
                    //     set.push("");
                    // }
                    setCollection({ ...collection, [f.field]: set })
                }

                var fv = filter[f.field];
                switch (f.type) {
                    case "bool":
                        if (filtered && fv && fv !== v) return false;
                        break;
                    case "daterange":
                        if (filtered && fv && (moment(v) >= moment(fv[1]) || moment(v) <= moment(fv[0]))) return false;
                        break;
                    case "date":
                        if (filtered && fv && ((moment(v).date() !== moment(fv).date()) || (moment(v).month() !== moment(fv).month()) || (moment(v).year() !== moment(fv).year()))) return false;
                        break;
                    case "string":
                        if (filtered && fv && fv !== v) return false;
                        break;
                    default:
                        break;
                }
            }
            return true;
        });
    };

    const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
    const page = (c.length >= current) ? c[current - 1] : (c.length !== 0) ? c[0] : [];

    const onChange = page => {
        setCurrent(page);
    };
    const onFilterChangeBool = (value, item) => {
        setFilter({ ...filter, [item.field]: value })
    };
    function onFilterChangeDate(dateStrings, item) {
        // console.log(dateStrings)
        setFilter({ ...filter, [item.field]: dateStrings })
    }
    const onFilterChangeString = (value, item) => {
        setFilter({ ...filter, [item.field]: value })
    };
    const onSortingChangeString = (value, item) => {
        setSorting({ field: value, order: sorting.order, f: (item && item.value) ? item.value : () => "" })
    };
    const sortingOrder = (e) => {
        e.stopPropagation();
        if (sorting.order === "ASC") {
            setSorting({ field: sorting.field, order: "DESC", f: sorting.f });
        } else {
            setSorting({ field: sorting.field, order: "ASC", f: sorting.f });
        }
    }
    const filters_ui = filters => {
        const fl = filters.filter(i => i.filter);
        const f = fl.map((item, idx) => {
            const componentValue = item => {
                if (!item.filter) return <></>;
                switch (item.type) {
                    case "bool":
                        return (
                            // <CheckboxItem 
                            //     checked={filter[item.field]}
                            //     onChange={(e) => onFilterChangeBool(e.target.checked, item)}>
                            //         {item.name}
                            // </CheckboxItem>
                            <List.Item
                                className={classes.Boolean}
                                extra={<Switch
                                    checked={filter[item.field]}
                                    onChange={(e) => onFilterChangeBool(e, item)}
                                    platform="android"
                                />}
                            >{item.name}</List.Item>
                        );
                    case "daterange":
                        var a = undefined;
                        if (filter[item.field] && filter[item.field][0] && filter[item.field][1]) {
                            a = [];
                            a.push(moment(filter[item.field][0]))
                            a.push(moment(filter[item.field][1]))
                        }
                        return <>
                            <SwipeAction
                                autoClose
                                right={[

                                    {
                                        text: (<Icofont icon="close" />),
                                        onPress: () => {
                                            onFilterChangeDate(undefined, item)
                                        },
                                        style: { backgroundColor: '#F4333C', color: 'white' },
                                    },
                                ]}
                            >
                                <CalendarItem
                                    name={item.name}
                                    className={classes.Time}
                                    value={a}
                                    onChange={(value) => {
                                        onFilterChangeDate(value, item)
                                    }}
                                />
                            </SwipeAction>
                        </>
                    case "date":
                        return (
                            <SwipeAction
                                autoClose
                                right={[

                                    {
                                        text: (<Icofont icon="close" />),
                                        onPress: () => {
                                            onFilterChangeDate(undefined, item)
                                        },
                                        style: { backgroundColor: '#F4333C', color: 'white' },
                                    },
                                ]}
                            >
                                <DatePicker
                                    mode="date"
                                    title="Выберите дату"
                                    extra=""
                                    locale={{
                                        DatePickerLocale: {
                                            year: "",
                                            month: "",
                                            day: "",
                                            hour: "",
                                            minute: "",
                                            am: "",
                                            pm: ""
                                        },
                                        okText: "Выбрать",
                                        dismissText: "Отмена"
                                    }}
                                    value={filter[item.field]}
                                    onChange={date => onFilterChangeDate(date, item)}
                                >
                                    <List.Item className={classes.Time} arrow="horizontal">{item.name}</List.Item>
                                </DatePicker>
                            </SwipeAction>
                        );
                    case "string":
                        var options = collection[item.field];
                        const oui = [];
                        if (options) {
                            var i = 1;
                            options.forEach((value) => {
                                oui.push({
                                    label: value,
                                    value: value,
                                    item
                                });
                            });
                        }
                        return (
                            <SwipeAction
                                autoClose
                                right={[

                                    {
                                        text: (<Icofont icon="close" />),
                                        onPress: () => {
                                            onFilterChangeString(undefined, item)
                                        },
                                        style: { backgroundColor: '#F4333C', color: 'white' },
                                    },
                                ]}
                            >
                                <Picker
                                    // title={<div onClick={() => {
                                    //     onFilterChangeString(undefined, item)
                                    // }}><Icofont icon="close" /> Очистить</div>}
                                    data={oui}
                                    cols={1}
                                    value={[filter[item.field]]}
                                    extra={<></>}
                                    onOk={value => {
                                        if (value.length) {
                                            onFilterChangeString(value[0], item)
                                        }
                                    }}
                                    okText="Выбрать"
                                    dismissText="Отмена">
                                    <List.Item className={classes.Obj} arrow="horizontal">
                                        {item.name}
                                    </List.Item>
                                </Picker>
                            </SwipeAction>
                        );
                    default:
                        return (<></>);
                }
            }
            return (
                <div key={idx} style={{ /*marginBottom: "10px" */ }}>
                    {/* {item.filter && item.type !== "bool" && <div>{item.name}</div>} */}
                    {componentValue(item)}
                </div>
            );
        });
        return (
            <>
                {(fl.length > 0) && <>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                        <div style={{
                            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "rgba(0, 0, 0, 0.85)",
                            padding: "0px 21px 0px 11px"
                        }}>
                            Фильтры
                        </div>
                        <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                        <Switch
                            checked={filtered}
                            onChange={() => {
                                setFiltered(!filtered);
                            }}
                            platform="android"
                        />
                    </div>
                    <div style={{ margin: "10px" }}>
                        <div>
                            <List style={{ backgroundColor: 'white' }} className="picker-list">
                                {f}
                            </List>
                        </div>
                    </div>
                </>}
            </>
        );
    };
    const sorting_ui = filters => {
        const so = filters.filter(f => f.sort);
        const s = so.map((item, idx) => {
            return {
                label: item.name,
                value: item.field,
                item
            };
        });
        const l = s.find(e => e.value === sorting.field);
        return (
            <>
                {(so.length > 0) && <div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", marginTop: "25px", paddingRight: "10px" }}>
                        <div style={{
                            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "rgba(0, 0, 0, 0.85)",
                            padding: "0px 21px 0px 11px"
                        }}>
                            Сортировка
                        </div>
                        <div style={{ flex: "auto", margin: "10px 10px", height: "1px", backgroundColor: "#f0f0f0" }}></div>
                        <div>
                            {sorting.order === "ASC" &&
                                <Button icon={<SortAscendingOutlined />} onClick={sortingOrder} />
                            }
                            {sorting.order === "DESC" &&
                                <Button icon={<SortDescendingOutlined />} onClick={sortingOrder} />
                            }
                        </div>
                    </div>
                    <div style={{ margin: "10px" }}>
                        <List style={{ backgroundColor: 'white' }} className="picker-list">
                            <Picker
                                data={s}
                                cols={1}
                                value={[sorting.field]}
                                extra={<></>}
                                onOk={value => {
                                    if (value.length) {
                                        onSortingChangeString(value[0], filters.find(i => i.field === value[0]))
                                    }
                                }}
                                okText="Выбрать"
                                dismissText="Отмена">
                                <List.Item className={classes.Obj} arrow="horizontal">
                                    {/* {l && l.label} */}
                                    {/* Сортировка */}
                                </List.Item>
                            </Picker>
                        </List>
                        {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ width: "100%", marginRight: "5px" }}>
                                <Select
                                    allowClear={true}
                                    value={sorting.field}
                                    onChange={(value) => onSortingChangeString(value, filters.find(i => i.field === value))}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: "100%" }}
                                >{s}</Select>
                            </div>
                            <div>
                                {sorting.order === "ASC" &&
                                    <Button icon={<SortAscendingOutlined />} onClick={sortingOrder} />
                                }
                                {sorting.order === "DESC" &&
                                    <Button icon={<SortDescendingOutlined />} onClick={sortingOrder} />
                                }
                            </div>
                        </div> */}
                    </div>
                </div>}
            </>
        );
    };
    const ui = (page) => {
        // if (!page || page.length <= 0) return <div></div>;
        if (item && page && page.length > 0) {
            const list = page.map((item) => {
                return item(page);
            });
            return list;
        }
        if (content) {
            return content(page, filtered);
        }
    };
    const componentRef = useRef();
    const setOpenedAndFiltered = (checked) => {
        // if(checked) setFiltered(checked);
        setOpened(checked);
    };
    return (
        <div className="filtered" style={{ position: "relative", height: "100%" }}>
            <div style={{ display: "none" }}><Print ref={componentRef} data={sortByFilters(filters, filterByFilters(filters, data))} filters={filters} title={title} /></div>
            <div style={{
                height: "43px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #f0f0f0",
                padding: "7px",
                borderRadius: "3px",
            }}>
                <div style={{ flex: "auto", paddingRight: "15px" }}>
                    {addition}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {(!noPrint && onPrint) &&
                        <a onClick={onPrint} className={classes.printLink} style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "12px", padding: "0px 7px" }}>
                            <Tag>
                                {/* <PrinterOutlined /> */}
                                <Icofont icon="printer" />
                            </Tag>
                        </a>
                    }
                    {(!noPrint && !onPrint) &&
                        <div>
                            {!printHref && <ReactToPrint
                                trigger={() => {
                                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                    // to the root node of the returned component as it will be overwritten.
                                    return <a href="#" className={classes.printLink} style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "12px", padding: "0px 7px", }}>
                                        <Tag>
                                            {/* <PrinterOutlined /> */}
                                            <Icofont icon="printer" />
                                        </Tag>
                                    </a>;
                                }}
                                content={() => componentRef.current}
                            />}
                            {printHref && <a target="_blank" rel="noopener noreferrer" href={printHref} className={classes.printLink} style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "12px", padding: "0px 7px" }}>
                                <Tag>
                                    {/* <PrinterOutlined /> */}
                                    <Icofont icon="printer" />
                                </Tag>
                            </a>}
                        </div>
                    }
                    <Tag style={{ cursor: "pointer" }} className={(filtered) ? "am-tag-active" : ""} checked={opened} onChange={checked => setOpenedAndFiltered(checked)}>
                        {!filtered && <FilterOutlined />}
                        {filtered && <Icofont icon="filter" />}
                    </Tag>
                </div>
            </div>
            <Popup
                visible={opened}
                onMaskClick={() => setOpenedAndFiltered(!opened)}
                position='right'
                bodyStyle={{ width: '80vw' }}
            >
                <div className='sidebar'>
                    {quickFilter && <div style={{ margin: "10px" }}>
                        <Input.Search placeholder="Поиск" allowClear onSearch={quickFilterValueChange} />
                    </div>}
                    {sorting_ui(filters)}
                    {filters_ui(filters)}
                </div>
            </Popup>
            {ui(page)}
            <div style={{ backgroundColor: "transparent", height: "25px", paddingBottom: "40px" }}>
                {/* <Pagination total={c.length} current={current} locale={locale} onChange={onChange}/> */}
                <PageIndicator total={c.length} current={current} />
            </div>
        </div>
    );
}

